import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_BUSINESS,
    UPDATE_BUSINESS,
    CREATE_BUSINESS, DELETE_BUSINESS,
    GET_BUSINESS
} from 'constants/businesses.constants'
import axios from 'axios'
import {
    fetchBusinesssSuccess,
    updateBusinessSuccess,
    createBusinessSuccess,
    deleteBusinessSuccess,
    getBusinessSuccess
} from "actions/businesses.action";
import { showErrors, stopLoader } from "actions/general.action";

// business sagas

const fetchBusinesssRequest = async (page) => {
    return axios.get('/api/v1/super_admin/businesses');
}

function* fetchBusinesss({ payload }) {
    try {
        const reuslt = yield call(fetchBusinesssRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchBusinesssSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updateBusinesssRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.partner_type = {id: payload.business_type_id}
    o.country = {id: payload.country_id}

    return axios.put('/api/v1/super_admin/businesses/' + payload.id,
        o
    );
}

function* updateBusiness({ payload }) {
    try {
        const reuslt = yield call(updateBusinesssRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateBusinessSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const createBusinesssRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.package = {id: payload.pack}

    return axios.post('/api/v1/super_admin/businesses',
        o
    );
}

function* createBusiness({ payload }) {
    try {
        const reuslt = yield call(createBusinesssRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield all([
                put(createBusinessSuccess(reuslt.data)),
                //put(stopLoader("Business created"))
            ])
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const deleteBusinesssRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/businesses/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteBusiness({ payload }) {
    try {
        const reuslt = yield call(deleteBusinesssRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteBusinessSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const getBusinesssRequest = async (id) => {
    return axios.get('/api/v1/super_admin/businesses/' + id);
}

function* getBusiness({ payload }) {
    try {
        const reuslt = yield call(getBusinesssRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(getBusinessSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

// fork business
export function* forkFetchBusinesss() {
    yield takeEvery(FETCH_ALL_BUSINESS, fetchBusinesss);
}

export function* forkUpdateBusiness() {
    yield takeEvery(UPDATE_BUSINESS, updateBusiness);
}

export function* forkCreateBusiness() {
    yield takeEvery(CREATE_BUSINESS, createBusiness);
}

export function* forkDeleteBusiness() {
    yield takeEvery(DELETE_BUSINESS, deleteBusiness);
}

export function* forkGetBusiness() {
    yield takeEvery(GET_BUSINESS, getBusiness);
}

export default function* rootSaga() {
    yield all([
        fork(forkFetchBusinesss),
        fork(forkUpdateBusiness),
        fork(forkCreateBusiness),
        fork(forkDeleteBusiness),
        fork(forkGetBusiness),
    ]);
}